var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configurator__counter"},[_c('span',[_vm._v(_vm._s(_vm.readySteps)+" ")]),_vm._v("шаг из "),_c('span',[_vm._v(_vm._s(_vm.allSteps))])])
}
var staticRenderFns = []

export { render, staticRenderFns }